import type { PathLookupAdvancedOptions } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface SaveAdvancedOptionsCommand {
  advancedOptions: PathLookupAdvancedOptions;
  name: string;
}

export const saveAdvancedOptions: GraphCommandFactory<
  SaveAdvancedOptionsCommand
> = (cmdContext) => async (command) => {
  try {
    const newAdvancedOptions = await cmdContext.api.request({
      url: '/graphs/path-lookup/advanced-options',
      method: 'POST',
      data: {
        name: command.name,
        ...command.advancedOptions,
      },
    });

    cmdContext.updateState((draft) => {
      draft.pathlookup.advancedOptions = [
        ...draft.pathlookup.advancedOptions,
        newAdvancedOptions,
      ];
      draft.pathlookup.selectedAdvancedOptions = newAdvancedOptions;
    });

    cmdContext.showNotification({
      type: 'success',
      message:
        cmdContext.msg.canvasGraph.graphSidePanel.pathlookup.advancedOptions
          .saved,
    });
  } catch (e) {
    cmdContext.updateState((draft) => {
      draft.loading = 'ERROR';
    });
    cmdContext.logError(e, 'GRAPH');
  }
};
